import type { AppListenerMiddleware } from "@src/store";
import { setupAiSideEffectListener } from "./setupAiSideEffectListener";
import { setupMixPanelListener } from "./setupMixPanelListener";

export function setupAiListener(middleware: AppListenerMiddleware) {
  setupAiSideEffectListener(middleware);
  setupMixPanelListener(middleware);
}
